module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperProposalModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SPM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCarSegmentSelect",
      "afterChange": (_vm.selectedCarModel = ''),
      "placeholder": _vm.lang.SPM002,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedCarSegment),
      callback: function($$v) {
        _vm.selectedCarSegment = $$v
      },
      expression: "selectedCarSegment"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.carSegmentList), function(segment) {
    return _c('option', {
      key: segment.CarSegmentGuid,
      domProps: {
        "value": segment.CarSegmentGuid
      }
    }, [_vm._v("\n                " + _vm._s(segment.CarSegmentName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCarModelSelect",
      "afterChange": (_vm.selectedCompetitorCar = ''),
      "placeholder": _vm.lang.SPM003,
      "allowClear": true,
      "disabled": !_vm.selectedCarSegment
    },
    model: {
      value: (_vm.selectedCarModel),
      callback: function($$v) {
        _vm.selectedCarModel = $$v
      },
      expression: "selectedCarModel"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.carModelsOfSelectedSegment), function(model) {
    return _c('option', {
      key: model.CarModelGuid,
      domProps: {
        "value": model.CarModelGuid
      }
    }, [_vm._v("\n                " + _vm._s(model.CarModelName) + "\n              ")])
  })], 2)], 1)]), _vm._v(" "), (_vm.check.CompetitorCarModelDistribution) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCompetitorCarModelSelect",
      "afterChange": (_vm.selectedCarModel = ''),
      "placeholder": _vm.lang.SPM005,
      "allowClear": true,
      "disabled": !_vm.selectedCarSegment
    },
    model: {
      value: (_vm.selectedCompetitorCar),
      callback: function($$v) {
        _vm.selectedCompetitorCar = $$v
      },
      expression: "selectedCompetitorCar"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.check.CompetitorCarModelDistribution), function(model) {
    return _c('option', {
      key: model.CompetitorCarModelGuid,
      domProps: {
        "value": model.CompetitorCarModelGuid
      }
    }, [_vm._v("\n                " + _vm._s(model.CompetitorCarModel) + "\n              ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalShopperSelect",
      "afterchange": function () {
        _vm.selectedShopperCar = '';
        _vm.getShopperCars();
      },
      "placeholder": _vm.lang.SPM007,
      "allowClear": true,
      "disabled": _vm.anyShopperAlreadyApproved
    },
    model: {
      value: (_vm.selectedShopper),
      callback: function($$v) {
        _vm.selectedShopper = $$v
      },
      expression: "selectedShopper"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.unproposedShoppers), function(shopper) {
    return _c('option', {
      key: shopper.ShopperGuid,
      domProps: {
        "value": shopper.ShopperGuid
      }
    }, [_vm._v("\n                " + _vm._s(shopper.ShopperName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-fab",
    attrs: {
      "disabled": !_vm.selectedShopperCar ||
        !_vm.selectedCarSegment ||
        (!_vm.selectedCarModel && !_vm.selectedCompetitorCar)
    },
    on: {
      "click": function($event) {
        return _vm.addShopper()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-green"
  }, [_vm._v("add")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-inline"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM008))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalShopperCarSelect",
      "placeholder": _vm.lang.SPM009,
      "allowClear": true,
      "disabled": !_vm.selectedShopper
    },
    model: {
      value: (_vm.selectedShopperCar),
      callback: function($$v) {
        _vm.selectedShopperCar = $$v
      },
      expression: "selectedShopperCar"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.shopperCars), function(car) {
    return _c('option', {
      key: car.ValueGroupGuid,
      domProps: {
        "value": car.ValueGroupGuid
      }
    }, [_vm._v("\n                " + _vm._s(car.Brand) + " " + _vm._s(car.Model) + " (" + _vm._s(car.Year) + ")\n              ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-inline"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCarMatch),
      expression: "selectedCarMatch"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCarMatchSelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCarMatch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "+"
    }
  }, [_vm._v("+ " + _vm._s(_vm.lang.SPM010))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "="
    }
  }, [_vm._v("= " + _vm._s(_vm.lang.SPM011))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-"
    }
  }, [_vm._v("- " + _vm._s(_vm.lang.SPM012))])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.check && _vm.check.ShopperProposals) ? [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM013) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM014) + " (" + _vm._s(_vm.lang.SPM015) + ")\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM016) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM017) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM018) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.check.ShopperProposals), function(proposal) {
    return _c('tr', {
      key: proposal.ShopperProposalGuid
    }, [_c('td', [_vm._v(_vm._s(proposal.ShopperId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(proposal.DisplayName))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(proposal.CarModelName) + "\n                  "), (proposal.CarSegmentName) ? [_vm._v("(" + _vm._s(proposal.CarSegmentName) + ")")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(proposal.ShopperCar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(proposal.CarMatch))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn nopadding",
      attrs: {
        "id": ("openProposalFeedButton-" + (proposal.ShopperProposalGuid))
      },
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("forum")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("openProposalFeedButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM019))]), _vm._v(" "), (proposal.UpdateShopperProposal) ? [_c('button', {
      staticClass: "btn nopadding",
      attrs: {
        "id": ("updateShopperDataButton-" + (proposal.ShopperProposalGuid))
      },
      on: {
        "click": function($event) {
          return _vm.updateShopperData(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("refresh")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("updateShopperDataButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM020))])] : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn nopadding",
      attrs: {
        "id": ("deleteShopperProposalButton-" + (proposal.ShopperProposalGuid)),
        "disabled": proposal.AgencyApprovalStatus
      },
      on: {
        "click": function($event) {
          return _vm.deleteShopper(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("deleteShopperProposalButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM021))])], 2)])
  }), 0)])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SPM022) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4756388a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopperApproval/ShopperProposalModal.vue
// module id = 619
// module chunks = 1 2